import { BaseServiceSetup, context, utils } from '@wikia/ad-engine';

const logGroup = 'BlockthroughReadershipLinkExperiment';

/**
 * This experiment is used to test the BlockthroughReadershipLink integration
 * it will not have any variants - Blockthrough will handle A/B testing via their
 * own GEO selection.
 */
export class BlockthroughReadershipLinkExperiment extends BaseServiceSetup {
	call(): void {
		this.configure();
	}

	private loadScript(): void {
		// The script below should load 'https://cdn.btmessage.com/script/rlink.js?o=5199505043488768';
		const libraryUrl = 'https://btloader.com/tag?o=5199505043488768&upapi=true';

		utils.logger(logGroup, 'loading', libraryUrl);
		utils.timedPartnerScriptLoader
			.loadScriptWithStatus(libraryUrl, logGroup, true, 'first')
			.then(() => {
				utils.logger(logGroup, 'ready');
			});
	}

	private isExperimentEnabled(): boolean {
		return (this.instantConfig.get('icExperiments', []) as string[]).includes(
			'BlockthroughReadershipLink',
		);
	}

	public configure(): void {
		if (this.isExperimentEnabled()) {
			utils.logger(logGroup, 'BlockthroughReadershipLink experiment enabled');
			context.set('experiments.BlockthroughReadershipLink', true);
			this.loadScript();
		} else {
			utils.logger(logGroup, 'BlockthroughReadershipLink experiment disabled');
			context.set('experiments.BlockthroughReadershipLink', false);
		}
	}
}
